import styled from '@emotion/styled';
import React, { useEffect, useState } from 'react';
import { AiOutlineDown } from 'react-icons/ai';
import { Link, useLocation } from 'react-router-dom';
import type { MenuRouteObject } from '../router/menu-routes';
import { menus } from '../router/menu-routes';

type Props = {};

const MenuWrapper = styled.div`
	position: relative;
	width: 240px;
	overflow: hidden;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	background-color: #fafafa;
	z-index: 9;
	color: #333;
	font-size: 16px;
	white-space: nowrap;

	.-btn {
		padding: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		cursor: pointer;
		color: #333;
		text-decoration: none;

		&:hover {
			background-color: #f0f0f0;
		}

		&.-active {
			background-color: #f0f0f0;
		}
	}
`;

const BtnWrapper = styled.div<{
	isShow: boolean;
}>`
	.-child-menu {
		padding-left: 8px;
		overflow: hidden;
		max-height: ${(props) => (props.isShow ? '999px' : 0)};
		transition: all 200ms ease-in-out;
	}

	svg {
		transition: all 200ms ease-in-out;
		transform: rotate(${(props) => (props.isShow ? '0' : '-90deg')});
	}
`;

const LinBtn: React.FC<{ children: React.ReactNode; to?: string; className: string }> = ({
	children,
	to = '',
	className,
}) => {
	const { pathname } = useLocation();
	const isActive = pathname === (to || '/');

	return (
		<Link to={to} className={`${className} ${isActive ? '-active' : ''}`}>
			{children}
		</Link>
	);
};

const ExpendBtn = ({ floor, index, menu }: { floor: number; index: number; menu: MenuRouteObject }) => {
	const [isShow, setIsShow] = useState(false);
	const location = useLocation();

	useEffect(() => {
		const menupaths = menu.childMenu?.map((item) => item.path);
		if (menupaths?.indexOf(location.pathname) !== -1) {
			setIsShow(true);
		}
	}, [location, menu.childMenu]);

	return (
		<BtnWrapper isShow={isShow}>
			<div
				onClick={() => {
					setIsShow(!isShow);
				}}
				className="-btn"
			>
				{menu.name}
				<AiOutlineDown />
			</div>
			<div className="-child-menu">{renderMenu(menu.childMenu || [], floor + 1)}</div>
		</BtnWrapper>
	);
};

const renderMenu = (menus: MenuRouteObject[], floor = 0) => {
	return menus.map((menu, index) => {
		return menu.childMenu ? (
			<ExpendBtn floor={floor} index={index} menu={menu} key={`${floor}+${index}`} />
		) : (
			<LinBtn to={menu.path} key={`${floor}+${index}`} className="-btn">
				{menu.name}
			</LinBtn>
		);
	});
};

const Menu = (props: Props) => {
	return <MenuWrapper>{renderMenu(menus)}</MenuWrapper>;
};

export default Menu;
